module.exports = __webpack_public_path__ + "img/metrics-icon.32ab8cbf.svg";